function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 25,
    style: {
      fill: "blue",
      font: "12px sans-serif"
    }
  }, "\n    Ford\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFord);
export default __webpack_public_path__ + "static/media/ford.44c9645d5fa2b935e47182281624201f.svg";
export { ForwardRef as ReactComponent };